import React, { useEffect, useState } from "react";
import projectsData from "../../data/projects.json";
import "./Css/Projects.css";
import LoadingSpinner from "./LoadingSpinner";

// New component to render subtitle with clickable URL if present.
const SubtitleWithLinks = ({ subtitle }) => {
  const urlRegex = /(https?:\/\/[^\s)]+)/g; // regex to detect URL (ignores trailing ')')
  const parts = subtitle.split(urlRegex);

  return (
    <p style={{ marginBottom: "10px", fontStyle: "italic" }}>
      {parts.map((part, index) =>
        urlRegex.test(part) ? (
          <a
            key={index}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "blue", textDecoration: "underline" }}
          >
            {part}
          </a>
        ) : (
          part
        )
      )}
    </p>
  );
};

const ProjectCard = ({ project }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const prevImage = () => {
    setCurrentImageIndex(
      currentImageIndex === 0
        ? project.images.length - 1
        : currentImageIndex - 1
    );
  };

  const nextImage = () => {
    setCurrentImageIndex(
      currentImageIndex === project.images.length - 1
        ? 0
        : currentImageIndex + 1
    );
  };

  return (
    <div className="project-card">
      <div className="project-text">
        <h2 style={{ fontSize: "1.7rem" }}>{project.title}</h2>
        <p>Technologies - {project.technologies}</p>
        <br />
        {/* Use the SubtitleWithLinks component here */}
        <SubtitleWithLinks subtitle={project.subtitle} />
        <p>{project.description}</p>
      </div>
      <div className="project-slideshow">
        <button className="arrow left-arrow" onClick={prevImage}>
          &#10094;
        </button>
        <img
          src={project.images[currentImageIndex].src}
          alt={project.images[currentImageIndex].alt}
          className="slideshow-image"
        />
        <button className="arrow right-arrow" onClick={nextImage}>
          &#10095;
        </button>
        <div className="image-counter">
          {currentImageIndex + 1} / {project.images.length}
        </div>
      </div>
    </div>
  );
};

const Experience = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 700);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="experience-container">
      <div className="experience-header">
        {/* <PageHeader title="Projects" subtitle="" /> */}
      </div>
      <div className="projects-list">
        {projectsData.projects.map((project) => (
          <ProjectCard key={project.id} project={project} />
        ))}
      </div>
    </div>
  );
};

export default Experience;
